export default __webpack_public_path__ + "static/media/bg_card_tracking_header.0278c7bb.svg";